export interface DashboardViewModel {
  totalInvoice: string;
  totalInvoiceBefore: number;
  count: number;
  countBefore: number;
  transitTime: string;
  transitTimeBefore: number;
  nacionalization: string;
  nacionalizationBefore: number;
  leadTimeBefore: number;
  leadTime: string;
  containersInProduction: number;
  graphs: GraphViewModel[];
}

export interface GraphViewModel {
  title: string;
  property: string;
  values: GraphValueViewModel[];
  before?: number;
}

export interface GraphValueViewModel {
  label: string;
  unLabel: string;
  numberOfProcesses: number;
  code: string;
  ncm: string;
  origin: string;
  usd: number;
  color: string;
}

export interface DashboardQuery {
  isUrgent?: boolean;
  processId?: string;
  columns?: string[];
  dateType?: string;
  multiStatus?: string;
  importMode?: string;
  currency?: string;
  initialDate?: string;
  active?: boolean;
  paymentInitialDate?: string;
  paymentFinalDate?: string;
  graphType?: string;
  finalDate?: string;
  ncm?: string;
  departurePort?: string;
  customsAgent?: string;
  dischargePort?: string;
  companyId?: string;
  countryOfOrigin?: string;
  cvfRef?: string;
  exporter?: string;
  name?: string;
  product?: string;
  poNumber?: string;
  status?: string;
  clientRef?: string;
  pageNumber?: number;
  getAll?: boolean;
  getStatus?: boolean;
  pageSize?: number;
  type?: number;
  sortField?: string;
  sortDirection?: string;
  cnyValue?: string;
  eurValue?: string;
  jpyValue?: string;
  chfValue?: string;
  sekValue?: string;
  responsible?: string;
  insurance?: string;
  teamId?: string;
}

// Brand-anchored chart palette (same family as theme avatarColor), softer harmonics after.
export const dashboardColors = [
  "#2563eb",
  "#7c3aed",
  "#db2777",
  "#ea580c",
  "#16a34a",
  "#0891b2",
  "#ca8a04",
  "#4f46e5",
  "#0ea5e9",
  "#e11d48",
  "#f59e0b",
  "#14b8a6",
  "#8b5cf6",
  "#ec4899",
  "#22c55e",
  "#3b82f6",
  "#a855f7",
  "#f97316",
  "#06b6d4",
  "#84cc16",
  "#6366f1",
  "#d946ef",
  "#10b981",
  "#eab308",
  "#0284c7",
  "#9333ea",
  "#f43f5e",
  "#65a30d",
  "#0d9488",
  "#7e22ce",
];

const channelColorMap: Record<string, string> = {
  verde: "#16a34a",
  vermelho: "#dc2626",
  amarelo: "#eab308",
  cinza: "#6b7280",
};

export const getChannelColor = (label: string | undefined, i: number) =>
  channelColorMap[(label ?? "").trim().toLowerCase()] ??
  dashboardColors[i % dashboardColors.length];
